// H5 order module routes.
import type { RouteRecordRaw } from "vue-router";

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: "/orders",
    name: "orders",
    component: () => import("@/modules/order/pages/OrdersPage.vue"),
  },
  {
    path: "/orders/:orderId/pay",
    name: "order-payment",
    component: () => import("@/modules/order/pages/ReviewPaymentPage.vue"),
  },
  {
    path: "/orders/:orderId",
    name: "order-detail",
    component: () => import("@/modules/order/pages/OrderDetailsPage.vue"),
  },
];
